import React, { useState } from "react";
import axios from "axios";

import {
  Button,
  Input,
  InputGroup,
  InputRightElement,
  useDisclosure,
  Spinner,
} from "@chakra-ui/react";
import { toast } from "react-hot-toast";
import { BiShowAlt, BiHide } from "react-icons/bi";
import { verifyAdmin } from "../utils/api";

const AdminCredential = () => {
  const [adminCredential, setAdminCredential] = useState("");
  const [show, setShow] = useState(false);
  const [credentialsMatch, setCredentialsMatch] = useState(false);
  const [loading, setLoading] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure();

  const handleClick = () => setShow(!show);
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); // Start the loading state
    try {
      const response = await axios.post(
        "https://portfolio-server-five-omega.vercel.app/login",
        { adminCredential }
      );
      if (response.data.success) {
        // Save the token to localStorage
        localStorage.setItem("tokenId", response.data.token);
        // Validate the credentials using the verifyAdmin function
        const isAdmin = await verifyAdmin(response.data.token);
        setCredentialsMatch(isAdmin);
        // Close the modal by calling onClose function
        onClose();
        toast.success('Got Credential!');
      } else {
        toast.error('An error occurred while verifying credentials. Please try again later.');
      }
    } catch (error) {
      console.error('Error:', error);
      toast.error('Invalid credentials. Please try again.');
    } finally {
      setLoading(false); // Stop the loading state
    }
  };
  
  
  
  

  return (
    <form
      onSubmit={handleSubmit}
      className="bg-[#374151] p-8 rounded shadow-md my-7 mx-3"
    >
      <h2 className="text-2xl text-white font-semibold mb-4">Admin Credential</h2>
      <p className="text-white mb-6">
        To access this feature, please provide valid admin credentials.
      </p>
      <InputGroup size="md">
        <Input
          pr="4.5rem"
          type={show ? "text" : "password"}
          placeholder="Enter admin credentials"
          className="text-white"
          value={adminCredential}
          onChange={(e) => {
            setAdminCredential(e.target.value);
            setCredentialsMatch(false);
          }}
          borderColor={credentialsMatch ? "green.400" : "gray.300"}
          _hover={{ borderColor: "green.400" }}
        />
        <InputRightElement width="4.5rem">
          <Button
            h="1.75rem"
            size="lg"
            bg="transparent"
            _hover={{ bg: "transparent" }}
            onClick={handleClick}
          >
            {show ? <BiHide color="white" /> : <BiShowAlt color="white" />}
          </Button>
        </InputRightElement>
      </InputGroup>
      <Button
      type="submit"
      isLoading={loading}
      bg="orange.500"
      _hover={{ bg: '#72B626' }}
      color="white" // Set text color to white
      loadingText="Logging In"
      className="mt-4 py-2 px-6 rounded transition duration-300 ease-in-out"
    >
      Login as Admin
    </Button>

    </form>
  );
};

export default AdminCredential;
